import { Icon } from '@blueprintjs/core';
import { Box, Text, VStack } from '@chakra-ui/react';

export function ZeroState({ title, icon, description }) {
    return (
        <Box w="100%" padding="20px" display="flex" flexDir="column" justifyContent="center" alignItems="center">
            <Text color="rgba(0,0,0,0.2)" mb="5px">
                <Icon icon={icon} size="64"></Icon>
            </Text>
            <Text fontSize="24px" color="rgba(0,0,0,0.4)" fontWeight="500" mb="10px">
                {title}
            </Text>
            <Text fontSize="14px" color="rgba(0,0,0,0.6)">
                {description}
            </Text>
        </Box>
    );
}
